import React from "react";
import TicketForm from "../../components/TicketForm";

export default function ChamadoTroca() {
  return (
    <TicketForm
      tipo="troca"
      title="Solicitar troca de equipamento"
      subtitle="Vamos cuidar disso pra você, com agilidade."
      alert={{
        tipo: "info",
        texto: "Selecione o equipamento da sua frota que deseja trocar. Apenas equipamentos ativos estão disponíveis.",
      }}
      motivos={[
        "Defeito mecânico — roda travada",
        "Defeito mecânico — estrutura danificada",
        "Desgaste natural",
        "Troca programada por contrato",
      ]}
      showUrgencia
      showFoto
    />
  );
}
